import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';

@Component({
    selector: 'app-new-property-use',
    templateUrl: '../../step/button-step/button-step.component.html',
    styleUrls: ['./property-use.component.scss', '../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})
export class PropertyUseComponent extends ButtonStepComponent implements OnInit {
  title : string = "How do you use this property?";
  hook = '👍 Primary, second home, or investment. All welcome.';
  buttonList = [
    { text: 'Primary Home', value: 'primary', imageName: 'primary-home', default: true },
    { text: 'Secondary Home', value: 'secondary', imageName: 'secondary-home' },
    { text: 'Investment Property', value: 'investment', imageName: 'investment-property' },
  ];

  ngOnInit() {
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('propertyUse', this.control);
  }

  submit(button: any): void {
    super.submit(button);
  }
}

/** FRU-24300: selected only by the rates form's dedicated DSCR-flow gate. No answer is preselected. */
@Component({
    selector: 'app-dscr-property-use',
    templateUrl: '../../step/button-step/button-step.component.html',
    styleUrls: ['./property-use.component.scss', '../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
    styles: [
      'h3.step-title { font-size: 1rem; font-weight: 400; line-height: 1.4; margin-bottom: 1rem; }',
      'button.icon-button .button-content div.button-image { box-sizing: border-box; height: 64px; }',
      'button.icon-button .button-content div.label { box-sizing: border-box; height: 52px; margin: 0 4px; padding: 0 0 4px; font-size: 14px; line-height: 1.1; }',
    ],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})
export class DscrPropertyUseComponent extends PropertyUseComponent {
  subtext = "DSCR loans qualify on the property's rental income, for rental and investment properties.";
  hook = undefined;
  buttonList = [
    { text: 'Rental or investment property', value: 'investment', imageName: 'investment-property' },
    { text: 'Primary Home', value: 'primary', imageName: 'primary-home' },
    { text: 'Secondary Home', value: 'secondary', imageName: 'secondary-home' },
  ];
}
